import { Flex } from '@chakra-ui/react'
import { ProductItem } from 'types/graphql'

import { ItListItemAnalyticsProps } from 'src/lib/hooks/analytics/useAnalytics'
import { BrandColor } from 'src/types'

import { PromoCodeInfo } from '..'

import ProductLinkButton from './ProductLinkButton/ProductLinkButton'

const ProductFooter = ({
  url,
  product,
  brandColor,
  trackingData,
  promoCodeInfo,
}: {
  url: string
  product: Partial<Omit<ProductItem, '__typename'>>
  profilePictureUrl: string
  brandColor: BrandColor
  trackingData: ItListItemAnalyticsProps
  promoCodeInfo?: PromoCodeInfo
}) => {
  const isOwner = trackingData.isOwner

  return (
    <>
      {product?.amazonUrl && (
        <ProductLinkButton
          promoCodeInfo={promoCodeInfo}
          brandColor={brandColor}
          product={product}
          trackingData={{ ...trackingData, itemUrl: product.amazonUrl }}
        />
      )}
      {url && (
        <ProductLinkButton
          promoCodeInfo={promoCodeInfo}
          directUrl={url}
          brandColor={brandColor}
          product={product}
          trackingData={trackingData}
        />
      )}
      {isOwner && !product?.amazonUrl && !url && (
        <Flex
          color="graphite"
          bg="air"
          p={4}
          width="100%"
          className="body-small-emphasis"
        >
          Add a Link...
        </Flex>
      )}
    </>
  )
}

export default ProductFooter
